



















































































































































































import SfMenuItemAccountCustom from "~/components/Customer/organisms/SfMenuItemAccountCustom.vue";
import {
  defineComponent,
  useContext,
  useRouter,
  useRoute,
  computed,
  useFetch,
  ref,
  onMounted,
} from "@nuxtjs/composition-api";
import { useSidebarLinkGroups } from "./useSidebarLinkGroups";
import { useUser } from "../../composables/useUser";
import AccountDashboardCard from "~/components/Customer/AccountDashboardCard.vue";
import { useLoyaltyStore } from "~/stores/extensionApi";
import { useVoucherStore } from "~/stores/extensionApi";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import VueBarcode from "vue-barcode";
import { useUserOrder } from "~/modules/customer/composables/useUserOrder";
import { useOrderStore } from "~/stores/extensionApi/order";

export default defineComponent({
  name: "MyAccount",
  components: {
    SfMenuItemAccountCustom,
    AccountDashboardCard,
    SkeletonLoader,
    VueBarcode,
  },
  middleware: "is-authenticated",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const { i18n, localeRoute } = useContext();
    const { user, load: loadUser, loading: loadingUser } = useUser();
    const confirmLogout = ref(false);

    const loyaltyStore = useLoyaltyStore();
    const loyaltyData = computed(() => loyaltyStore.getLoyaltyData);

    const voucherStore = useVoucherStore();
    const voucherData = computed(() => voucherStore.getVoucherData);
    const { listOrderByFilter, loading: loadingOrder } = useUserOrder();

    const phoneLogin = computed(() => user.value?.phone_number);
    const customerId = computed(() => user.value?.customer_id);
    const orderStore = useOrderStore();
    const listOrder = computed(() => orderStore.listOrder);

    useFetch(async () => {
      if (user.value === null) {
        await loadUser();
      }
      if (user.value && loyaltyData.value?.code !== 200) {
        await loyaltyStore.fetchLoyaltyDataStore();
      }
      if (voucherData.value?.code !== 200) {
        await voucherStore.fetchVoucherDataStore();
      }
      if (listOrder.value?.order?.length == 0 || !listOrder.value?.order) {
        const params = {
          phone_number: phoneLogin.value,
          customerId: customerId.value,
          limit: 5,
          offset: 0,
        };
        const results = await listOrderByFilter(params);
        if (results) {
          orderStore.$patch((state) => {
            state.listOrder = results;
          });
        }
      }
    });

    const { sidebarLinkGroups, logoutUser } = useSidebarLinkGroups();
    const isOnSubpage = computed(() => route.value.matched.length > 1);
    const goToTopLevelRoute = () =>
      router.push(localeRoute({ name: "customer" }));
    const title = computed(() =>
      i18n.t(route.value.matched.at(-1)?.meta?.titleLabel as string)
    );

    const confirmPopupChange = () => {
      confirmLogout.value = !confirmLogout.value;
    };

    const logout = () => {
      confirmLogout.value = true;
    };

    const confirmLogoutAction = () => {
      router.push(localeRoute("/"));
      confirmLogout.value = false;
      logoutUser();
    };

    const handlers = {
      "log-out": logout,
    };

    const getHandler = (id: string) => handlers[id] ?? {};

    const genderBackground = computed(() => {
      if (user?.value?.firstname?.includes("-")) return "transparent";
      if (user?.value?.gender === 2) return "#F48FB1";
      if (user?.value?.gender === 1) return "#55A67A";
      if (user?.value?.gender === 3) return "#9A6EC7";
      return "transparent";
    });

    const characterFirstName = computed(() => {
      const firstNameParts = user.value?.firstname?.split(" ");
      return firstNameParts?.length
        ? firstNameParts[firstNameParts.length - 1].charAt(0).toUpperCase()
        : "";
    });

    const isPhoneLogin = computed(() => user?.value?.firstname?.includes("-"));

    const fullName = computed(() => {
      return `${user?.value?.firstname?.replace(
        "-",
        " "
      )} ${user?.value?.lastname?.replace("-", " ")}`;
    });

    const isLinkActive = (link): boolean => {
      const currentPath = route.value.name;

      return currentPath.includes(link?.name) || currentPath === link?.name;
    };

    const loyaltyNameBarcode = computed(() => {
      if (loyaltyData.value?.result?.loyalty?.name) {
        return loyaltyData.value.result.loyalty.name;
      }
      return null;
    });

    return {
      user,
      sidebarLinkGroups,
      title,
      isOnSubpage,
      goToTopLevelRoute,
      logoutUser,
      getHandler,
      confirmLogout,
      confirmPopupChange,
      logout,
      confirmLogoutAction,
      characterFirstName,
      genderBackground,
      isPhoneLogin,
      fullName,
      loadingUser,
      isLinkActive,
      loyaltyNameBarcode,
    };
  },
});
